import { FC, MouseEvent, useCallback, useMemo } from 'react';
import { Checkbox } from '../checkbox';
import { Toggle } from '../toggle';
import { ListControlStyled } from './list-control.styled';
import { ETogglerType, IListControlProps } from './list-control.types';

const togglers = {
  [ETogglerType.TOGGLE]: Toggle,
  [ETogglerType.CHECKBOX]: Checkbox,
};

export const ListControl: FC<IListControlProps> = ({
  togglerType = ETogglerType.TOGGLE,
  children,
  checked,
  onCheck = () => {},
  ...props
}) => {
  const Toggler = useMemo(() => togglers[togglerType], [togglerType]);

  const clickHandler = useCallback(
    (e: MouseEvent) => {
      e.preventDefault();
      onCheck(!checked);
    },
    [checked, onCheck],
  );

  return (
    <ListControlStyled $isChecked={!!checked} onClick={clickHandler}>
      <Toggler
        {...props}
        checked={checked}
        onChange={e => onCheck(e.target.checked)}
      />
      {children}
    </ListControlStyled>
  );
};
